import * as Sentry from '@sentry/react';
import { type LoaderFunctionArgs, redirect } from 'react-router';
import ROUTES from '@/routes';
import { getAuth } from '@/stores/auth';

export async function protectedLayoutLoader({ request }: LoaderFunctionArgs) {
  const auth = await getAuth();

  if (auth) {
    Sentry.setUser({ id: auth.UserID });
    return null;
  }

  const url = new URL(request.url);
  const redirectPath = url.pathname + url.search;

  return redirect(ROUTES.AUTH.SIGN_IN.$buildPath({ searchParams: { redirect: encodeURIComponent(redirectPath) } }));
}
